import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FwAlertModule,
  FwAvatarModule,
  FwButtonModule,
  FwButtonToggleModule,
  FwCardModule,
  FwCheckboxModule,
  FwChipModule,
  FwContainedInputModule,
  FwDialogsModule,
  FwFormHeadingModule,
  FwIconButtonModule,
  FwIconModule,
  FwLayoutsModule,
  FwMenuModule,
  FwRadioModule,
  FwSectionHeadingModule,
  FwSelectMenuModule,
  FwSwitchModule,
  FwTextInputModule,
  FwTooltipModule,
  FwWrappedInputModule,
} from '@flywheel-io/vision';

import { AdminService } from './admin.service';
import { AppRegistrationDialogComponent } from './applications/app-registration-dialog.component';
import { CreateGroupDialogComponent } from './create-group-dialog/create-group-dialog.component';
import { AddDeviceDialog } from './devices/add-device-dialog/add-device-dialog.component';
import { AddDicomPeerDialog } from './devices/add-dicom-peer-dialog/add-dicom-peer-dialog.component';
import { StorageEditDialog } from './external-storage/storage-edit-dialog/storage-edit-dialog.component';
import { MaterialModule } from '../material.module';
import { RolesService } from './roles/roles.service';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { AddPermissionsDialogComponent } from './users/add-permissions-dialog/add-permissions-dialog.component';
import { CreateUserDialogComponent } from './users/create-user-dialog/create-user-dialog.component';
import { UserInformationComponent } from './users/user-information/user-information.component';
import { DeleteTaskPreviewDialogComponent } from './viewer-protocols/delete-task-preview/delete-task-preview-dialog.component';
import { ViewerProtocolEditorDialogComponent } from './viewer-protocols/viewer-protocols-list/viewer-protocol-editor/viewer-protocol-editor-dialog.component';
import { ViewerProtocolsListComponent } from './viewer-protocols/viewer-protocols-list/viewer-protocols-list.component';
import { MatSelectModule } from '@angular/material/select';
import { FeatureIfDirective } from '../shared/directives/feature-if.directive';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FeatureIfDirective,
    FormsModule,
    FwAlertModule,
    FwAvatarModule,
    FwButtonModule,
    FwButtonToggleModule,
    FwCardModule,
    FwCheckboxModule,
    FwChipModule,
    FwDialogsModule,
    FwFormHeadingModule,
    FwIconButtonModule,
    FwIconModule,
    FwContainedInputModule,
    FwLayoutsModule,
    FwMenuModule,
    FwWrappedInputModule,
    FwRadioModule,
    FwSectionHeadingModule,
    FwSelectMenuModule,
    FwSwitchModule,
    FwTextInputModule,
    FwTooltipModule,
    FwWrappedInputModule,
    MaterialModule,
    MatSelectModule,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    DeleteTaskPreviewDialogComponent,
    ViewerProtocolsListComponent,
  ],
  declarations: [
    AddDeviceDialog,
    AddDicomPeerDialog,
    AddPermissionsDialogComponent,
    AppRegistrationDialogComponent,
    CreateGroupDialogComponent,
    CreateUserDialogComponent,
    DeleteTaskPreviewDialogComponent,
    StorageEditDialog,
    ViewerProtocolEditorDialogComponent,
    ViewerProtocolsListComponent,
    UserInformationComponent,
  ],
  providers: [
    AdminService,
    RolesService,
  ],
})
export class AdminModule { }
